import SectionHeading from "@/components/feature/SectionHeading";
import GuideCard from "@/components/feature/GuideCard";
import { guides } from "@/mocks/guides";

export default function GuidesPreview() {
  return (
    <section className="mx-auto w-full max-w-content px-4 py-16 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="防骗指南"
        title="能立刻用上的识别与应对方法"
        description="不绕弯子，每篇只讲清楚关键动作。遇到类似情况时，照着做就能少踩一次坑。"
        action={{ label: "全部指南", path: "/guides" }}
      />
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {guides.slice(0, 3).map((item) => (
          <GuideCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}